module.exports = __webpack_public_path__ + "img/class1.20c38cc7.png";